export default angular.module('nv.shared.error-handling', ['ngMaterial', 'tandibar/ng-rollbar']).name;
